import React, { useContext } from "react";

import { Context, classDataPath } from "../../../teacherStore";
import SelectTextbook from "../../../templates/Select/Textbook";

export default () => {
  const { state } = useContext(Context);

  return (
    <SelectTextbook
      basicPath={classDataPath}
      activeLearningPath={`${classDataPath}?isActiveLearning=true`}
      has_base={state.has_base}
    />
  );
};
